// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__hsjml","aboutSection":"About_aboutSection__LJfEq","skills":"About_skills__RvndN"};